import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import ForcePasswordReset from './components/ForcePasswordReset';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import WipReportPage from './pages/WipReportPage';
import CompletedJobsPage from './pages/CompletedJobsPage';
import UsersAdminPage from './pages/UsersAdminPage';
import HelpPage from './pages/HelpPage';
import ChatPage from './pages/ChatPage';
import SettingsAdminPage from './pages/SettingsAdminPage';

function AppLayout({ children }) {
  return (
    <div className="app-layout">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="app-main">
          {children}
          <footer className="app-footer">Made with &hearts; by the CM Corp IT Department</footer>
        </main>
      </div>
    </div>
  );
}

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <img src="/logo.png" alt="CM Corp" className="loading-logo" />
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!user) return <LoginPage />;

  if (user.mustResetPassword) {
    return (
      <AppLayout>
        <ForcePasswordReset />
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/wip" element={<WipReportPage />} />
        <Route path="/completed" element={<CompletedJobsPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/ai" element={<ChatPage />} />
        {user.isAdmin && <Route path="/admin/users" element={<UsersAdminPage />} />}
        {user.isAdmin && <Route path="/admin/settings" element={<SettingsAdminPage />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppLayout>
  );
}
